import $ from 'jquery';

$('.faq-item__question').click(function () {
  $(this).siblings('.faq-item__answer').slideToggle(200);
  $(this).find('img').toggleClass('rotate'); // Добавляем/убираем класс rotate
});

function search() {
  if ($('.control--faq-search input').length === 0) {
    return;
  }

  const searchPhrase = $('.control--faq-search input').val().trim().toLowerCase();

  if (searchPhrase === '') {
    $('.faq-block').show();
    $('.faq-item').show();
  } else {
    $('.faq-block').hide();
    $('.faq-item').hide();
    $('.faq-item').each(function () {
      if ($(this).text().toLowerCase().indexOf(searchPhrase) > -1) {
        $(this).show()
          .parents('.faq-block')
          .show()
          .find('.faq-item__answer')
          .show();
      }
    });
  }
}

$('body').on('submit', '.faq-search', function (e) {
  e.preventDefault();
  search();
});

search();